module.exports = __webpack_public_path__ + "static/media/merchantBackground.ce4a1afe.png";